// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingApplyPromoCodeResponse

import { hydrateWidgetBookingPriceSummary, type WidgetBookingPriceSummary, type WidgetBookingPriceSummaryApiResponse } from './widgetBookingPriceSummary.gen';
import { hydratePromoCode, type PromoCode, type PromoCodeApiResponse } from './promoCode.gen';

export type BookingApplyPromoCodeApiResponse = {
	success: boolean;
	priceSummary: WidgetBookingPriceSummaryApiResponse;
	promoCode: PromoCodeApiResponse | null;
};

export type BookingApplyPromoCode = {
	success: boolean;
	priceSummary: WidgetBookingPriceSummary;
	promoCode: PromoCode | null;
};

export function hydrateBookingApplyPromoCode(data: BookingApplyPromoCodeApiResponse): BookingApplyPromoCode {
	return {
		...data,
		priceSummary: hydrateWidgetBookingPriceSummary(data.priceSummary),
		promoCode: data.promoCode ? hydratePromoCode(data.promoCode) : null,
	};
}